
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BreadcrumbComponent } from "src/app/components/shared/breadcrumb/breadcrumb.component";
import { MaterialModule } from "src/app/shared/material.module";
import { DigitalCard } from "../cards/cards.component";
import { AuthService } from "src/app/services/auth.service";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { Bookmark, BookmarkUiService } from "src/app/services/bookmark-service";


type ViewMode = 'grid' | 'list';

@Component({
  selector: 'app-bookmark',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule, BreadcrumbComponent],
  templateUrl: './bookmark.page.html',
  styleUrls: ['./bookmark.page.scss']
})


export class BookmarkPage implements OnInit {
  bookmarksWithCards: { bookmark: Bookmark; card: DigitalCard | null }[] = [];
  loading = true;
  error: string | null = null;
  viewMode: ViewMode = 'grid';
  searchTerm: string = '';

  constructor(
    private bookmarkUiService: BookmarkUiService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    const userId = this.authService.currentUser?.id || this.authService.currentUser?.uid;
    if (!userId) {
      this.error = 'User not authenticated';
      this.loading = false;
      return;
    }
    this.bookmarkUiService.getBookmarksWithCardData(userId).subscribe({
      next: (results) => {
        this.bookmarksWithCards = results;
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load bookmarks';
        this.loading = false;
      }
    });
  }
    hasSocialLinks(card: DigitalCard | null): boolean {
    return !!(card && Array.isArray(card.social_links) && card.social_links.length > 0);
  }

  get filteredBookmarks() {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return this.bookmarksWithCards;
    return this.bookmarksWithCards.filter(item => {
      const card = item.card;
      if (!card) return false;
      const contactName = (card.contact_info?.contactName || '').toLowerCase();
      const businessName = (card.business_info?.businessName || '').toLowerCase();
      const handler = (card.handler || '').toLowerCase();
      return (
        contactName.includes(term) ||
        businessName.includes(term) ||
        handler.includes(term)
      );
    });
  }

  onSearchChange(): void {
    this.searchTerm = this.searchTerm.trimStart();
  }

  viewCard(card: DigitalCard | null) {
    if (!card?.handler) return;
    const link = `${environment.baseUrl}/${card.handler}`;
    window.open(link, '_blank', 'noopener,noreferrer');
  }


  navigateToHandlerLink(card: DigitalCard | null): void {
    if (!card?.handler) return;
    const link = `/card/${card.handler}`;
    window.open(link, '_blank', 'noopener,noreferrer');
  }

  flipCard(cardElement: HTMLElement) {
    cardElement.classList.toggle('flipped');
  }

  getSmartTextColor(color1?: string, color2?: string): string {
    const c1 = color1 || '#ffffff';
    const c2 = color2 || c1;
    const hexToRgb = (hex: string) => {
      const cleaned = hex.replace('#', '');
      const bigint = parseInt(cleaned, 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
      };
    };
    const rgb1 = hexToRgb(c1);
    const rgb2 = hexToRgb(c2);
    const brightness1 = Math.sqrt(
      0.299 * rgb1.r * rgb1.r +
        0.587 * rgb1.g * rgb1.g +
        0.114 * rgb1.b * rgb1.b
    );
    const brightness2 = Math.sqrt(
      0.299 * rgb2.r * rgb2.r +
        0.587 * rgb2.g * rgb2.g +
        0.114 * rgb2.b * rgb2.b
    );
    const minBrightness = Math.min(brightness1, brightness2);
    return minBrightness > 130 ? '#000000' : '#ffffff';
  }
}
